module.exports = __webpack_public_path__ + "static/media/boston-scientific.102788c4.png";